import { Component, OnInit, Input } from '@angular/core';
import { EnvironmentService, TranslationService } from '@dch/ng-common';
import { CustomerAccount } from '@dch/common-business-logic';
import { IBillingAccount, IBillingDocument } from '@dch/billing-business-logic';
import { getFormattedURLFor } from '../../services/utils.service';
import {
  OVERVIEW_PAGE,
  SETTINGS_PAGE_TRANSLATION_KEY,
} from '../../config/my-bill.constants';
import { Router } from '@angular/router';
import { MyScarletService } from '../../services/my-scarlet.service';

@Component({
  selector: 'my-bill-faq-settings-container',
  templateUrl: './my-bill-faq-settings-container.component.html',
  standalone: false,
})
export class MyBillFaqSettingsContainerComponent implements OnInit {
  @Input() billingAccount?: IBillingAccount;
  @Input() customerAccount?: CustomerAccount;
  @Input() billingDocument?: IBillingDocument;
  @Input() zone: string;
  @Input() isResUser: boolean;

  settingsTitle = '';
  settingsLinkLabel = '';

  constructor(
    private translationService: TranslationService,
    private environmentService: EnvironmentService,
    private router: Router,
    private scarletService: MyScarletService
  ) {}

  ngOnInit() {
    const resUserKey = this.isResUser ? 'RES.' : '';
    this.settingsTitle = this.translationService.getTranslatedValueFor(
      `bills.redesign.settingsAndFaq.${resUserKey}settingsTitle`
    );

    this.settingsLinkLabel = this.translationService.getTranslatedValueFor(
      `bills.redesign.settingsAndFaq.${resUserKey}settingsLinkLabel`
    );
  }

  onClickOfBillPreferences() {
    if (this.environmentService.isSmoothAccess) {
      window.location.assign(
        window.location.href
          .replace(
            '/smoothAccess',
            this.scarletService.isScarlet() ? '/myscarlet' : '/myproximus'
          )
          .replace(this.router.url, OVERVIEW_PAGE)
      );
    } else {
      window.location.href = getFormattedURLFor(
        this.translationService.getTranslatedValueFor(
          SETTINGS_PAGE_TRANSLATION_KEY
        ),
        this.customerAccount?.getSegment()
      );
    }
  }
}
